import React from 'react';
import {useGlobal} from "reactn";
import {Avatar, Dropdown, Menu} from 'antd';

import {Link} from 'react-router-dom';
import {SettingOutlined} from '@ant-design/icons'
import Cookies from 'js-cookie'
import {env} from '../app.config';

const HeaderBar = (props) => {

    let [, setToken] = useGlobal("token");
    let [user, setUser] = useGlobal("user");

    let logout = (props) => {
        Cookies.remove('token')
        localStorage.removeItem('modules')
        setToken(null)
    }

    const menu = (
        <Menu className="head-menu">
            <Menu.Item>
                <Link to="adminInfo">Admin Bilgileri</Link>
            </Menu.Item>
            <Menu.Item>
                <Link to="/settings"><SettingOutlined/>Ayarlar</Link>
            </Menu.Item>
            <Menu.Divider/>
            <Menu.Item onClick={logout} danger> Çıkış Yap </Menu.Item>
        </Menu>
    );
    return (
        <div className="topMenu">
            <Dropdown overlay={menu} placement="bottomRight" arrow>

                <div><Avatar
                    onClick={(e) => e.preventDefault()}
                    className="ant-dropdown-link"
                    src="/images/default-avatar.svg"
                />
                </div>
            </Dropdown>
        </div>
    );
};


export default HeaderBar;
